module.exports = __webpack_public_path__ + "static/img/17017B_2_R_20190205_fit.9a9691a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17017B_2_R_20190205_fit.png
// module id = b90P
// module chunks = 0